
import Vue from 'vue'
import App from './App.vue'
// import '../static/js/flex'
import router from './router'
// import Vant from 'vant'

import axios from 'axios';
Vue.prototype.$ajax = axios;


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAxios from 'vue-axios'
import QS from 'qs'
// import 'vant/lib/index.css'
Vue.use(ElementUI,VueAxios,axios)
Vue.config.productionTip = false
// Vue.prototype.$axios = axios;
Vue.prototype.qs = QS;
// Vue.component('toast', Toast)

//导入后端接口api地址
import api from './api.js'
Vue.prototype.$api = api
Vue.prototype.url = 'http://www.henaniei.org.cn';



// 获取url地址栏的域名  作为api地址
var url = window.location.href;

// url中多了 ?file=# 的时候 用如下方法处理
// url = url.substring(0,url.match('#').index);
// if(url.indexOf('?')!=-1){
//   url = url.substring(0,url.indexOf('?'));
// }
// console.log(url)

// sessionStorage.setItem("url", url);
// Vue.prototype.$api = url+ 'index/'
// Vue.prototype.url = url;





new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js